import { ReactComponent as ThanxLogo } from 'assets/images/nav/nav_logo.svg'
import { buildTranslate } from 'locales'
import { ReactNode } from 'react'
import { Button } from 'react-bootstrap'
import './ThanxAIHeader.scss'

const t = buildTranslate('components.ai.header')

interface ThanxAIHeaderProps {
  onClose: () => void
  cancelText?: string
  rightAlignedNavItems?: ReactNode[]
  title?: string
  merchantName?: string
}

const ThanxAIHeader = ({
  onClose,
  cancelText,
  rightAlignedNavItems = [],
  title,
  merchantName,
}: ThanxAIHeaderProps) => {
  const navItems = rightAlignedNavItems.map((item, index) => (
    <div key={index} className="thanx-ai-header__nav-item">
      {item}
    </div>
  ))

  return (
    <header
      className="thanx-ai-header position-fixed w-100 d-flex align-items-center justify-content-between px-m white"
      role="banner"
      aria-label="Thanx AI Header"
    >
      <div className="thanx-ai-header__branding">
        <div className="thanx-ai-header__logo">
          <ThanxLogo className="thanx-ai-header__logo-svg" />
        </div>
        <span className="thanx-ai-header__ai-label">{t('ai_label')}</span>
        {title && (
          <span className="thanx-ai-header__title">
            {title}
            <span className="thanx-ai-header__beta-badge">BETA</span>
          </span>
        )}
        {merchantName && (
          <span className="thanx-ai-header__merchant-name">{merchantName}</span>
        )}
      </div>

      <div className="d-flex align-items-center">
        {navItems}
        <Button
          onClick={onClose}
          className="btn-inverted thanx-ai-header__cancel-btn"
        >
          {cancelText || t('cancel')}
        </Button>
      </div>
    </header>
  )
}

export default ThanxAIHeader
